import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { AppState, AppDispatch } from '../store';
import {
  CreateAIConversationRequest,
  SubmitMessageRequest,
} from '@store/actions/aiConversationAction';
import {
  createAIChatSession,
  resetState,
  sendMessageWithAI,
  clearAIMessage as clearAIMessageReducer,
  fetchCourseList,
  setCurrentCourse as setCurrentCourseReducer,
  CourseData,
  getVTeacherUrlRequest,
} from '@store/reducers/aiConversationReducer';

export const useAIConversation = () => {
  const dispatch: AppDispatch = useDispatch();

  const {
    aiMessage,
    currentSessionId,
    messages,
    suggestedQuestions,
    isLoading,
    isSending,
    courseList,
    currentCourse,
    vteacherUrl,
  } = useSelector((state: AppState) => state.aiConversation);

  const createChatSession = (request: CreateAIConversationRequest) => {
    dispatch(createAIChatSession(request));
  };

  const sendMessage = (request: SubmitMessageRequest) => {
    dispatch(sendMessageWithAI(request));
  };

  const clearChatSession = useCallback(() => {
    dispatch(resetState());
  }, []);

  const clearAIMessage = useCallback(() => {
    dispatch(clearAIMessageReducer());
  }, []);

  const getCourseList = useCallback(() => {
    dispatch(fetchCourseList());
  }, []);

  const setCurrentCourse = useCallback((course: CourseData): void => {
    dispatch(setCurrentCourseReducer(course));
  }, []);

  const getVTeacherUrl = useCallback((id: number) => {
    dispatch(getVTeacherUrlRequest({ id }));
  }, []);

  return {
    // State
    currentSessionId,
    aiMessage,
    messages,
    suggestedQuestions,
    isLoading,
    isSending,
    // Actions
    createChatSession,
    sendMessage,
    clearChatSession,
    clearAIMessage,
    getCourseList,
    setCurrentCourse,
    courseList,
    currentCourse,
    vteacherUrl,
    getVTeacherUrl,
  };
};
